import styled from "styled-components";

export const PrivilegeStyled = styled.div`
  &:hover {
    .figture_img {
      .image {
        transform: scale(1.2); /* Zoom in by 20% */
      }
    }
    .privilege_title {
      color: ${({ theme }) => theme.COLORS.PURPLE_10};
    }
  }
  .figture_img {
    margin-bottom: 10px;
    height: 139px;
    overflow: hidden;
    flex-shrink: 0;
    .image {
      margin-bottom: 10px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease-out; /* Smooth effect */
    }
  }
  .privilege_title {
    margin-bottom: 10px;
    color: ${({ theme }) => theme.COLORS.BLACK_3};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.GT_AMERICA_COMPRESSED_BOLD};
  }
  .privilege_subtitle {
    margin-bottom: 10px;
    color: ${({ theme }) => theme.COLORS.GRAY_12};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
  .privilege_date {
    color: ${({ theme }) => theme.COLORS.GRAY_12};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }

`;
